import React, { Component } from "react";
import { connect } from "react-redux";
import Sign from "../../components/forms/SigninPopup";
import { axiosUserManagement } from "../../axios";
import { withRouter } from "react-router-dom";

import { objectToArray, IsEmpty, sparkLoopReferralHandler } from "../../util/commonFunctions";
import { updateFormElements, checkFormValid } from "../../util/FormHelper";
import SigninConfig from "../../components/formsConfig/SinginConfig";
import Modal from "../../components/shared/Modal";

import { SiteConstants } from "../../constants/constant";
import SignupInit from "../../components/forms/Signup/SignupInit";
import SignupForm from "../../components/forms/Signup/SignupForm";
import SignupConfig from "../../components/formsConfig/SignupConfig";
import {
  setToken,
  setUser,
  setSignupInfo,
  showLoader,
  hideLoader,
  setSignupFlow,
  resetSignupFlow,
  setSignupModalStatus
} from "../../actions";
import { analytics } from "../../analytics";
import { handleActionError } from "../../util/error";



class SigninPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // activeStep: props.activePopup,
      activeStep: SiteConstants.SignupInit,
      ...{ SigninConfig },
      ...{ SignupConfig },
      btnDisabled: true,
      message: null,
      success: false,
      loader: false,
      openPopup: true,
      requestedForm: 'signin'
    };
    localStorage.setItem("userLastKnownLocation", window.location.href);
  }

  componentWillUnmount() {
    localStorage.removeItem(SiteConstants.Campaign);
  }


  lazyLoadComponent = stepName => {
    this.setState({
      activeStep: stepName,
      btnDisabled: true,
      success: false,
      message: null
    });
  };

  onChangeHandler = (event, formName) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    this.setState({
      [formName]: updatedFrom,
      btnDisabled: !checkFormValid(updatedFrom).formValid
    });
  };

  onBlurHandler = (event, formName) => {
    this.setState({
      [formName]: updateFormElements(event, "validation", this.state[formName]),
      btnDisabled: !checkFormValid(this.state[formName]).formValid
    });
  };

  onFormChangeHandler = (requestedForm) => {
    // this.setState({
    //   requestedForm: requestedForm
    // });
    this.props.setSignupModalStatus(true, requestedForm);
  };

  signInHandler = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      this.setState({
        [formName]: returnFormConfig.form,
        loader: true
      });
      for (let formElementIdentifier in this.state[formName]) {
        formData[formElementIdentifier] = this.state[formName][
          formElementIdentifier
        ].value;
      }
      axiosUserManagement
        .post("/form/authenticate", formData, {
          "cache-control": "no-cache",
          "content-type": "application/json"
        })
        .then(res => {
          localStorage.setItem("token", res.data.data);
          localStorage.setItem("userLastKnownLocation", window.location.href);
          this.props.setToken(res.data.data);
          this.getUserInfo(res.data.data);
          this.setState({
            loader: false,
            success: true
          });
        })
        .catch(err => {
          handleActionError("An error occurred while attempting to authenticate the subscriber:", err);
          this.setState({
            loader: false,
            message: err.response.data.message
          });
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  signUpHandler = formData => {
    let url = "/signUp";
    let config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json"
      }
    };
    this.props.showLoader();
    axiosUserManagement
      .post(url, formData, { ...config })
      .then(res => {
        try {
          if (!IsEmpty(localStorage.getItem("RH_REFLINK"))) { // user referral code found after login
            sparkLoopReferralHandler(localStorage.getItem("RH_REFLINK"), '', formData.email);
          }
          const search = this.props.location.search;
          const params = new URLSearchParams(search);
          campaignName = params.get(SiteConstants.Campaign);
          if (!campaignName) {
            var campaignName = localStorage.getItem(SiteConstants.Campaign);
          }
          if (campaignName) {
            analytics(`registration_complete_${campaignName}`);
            localStorage.removeItem(SiteConstants.Campaign);
          }
          this.setState({
            btnDisabled: false
          });
          this.closeModal();
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("userLastKnownLocation", window.location.href);
          this.props.setToken(res.data.data.token);
          this.getUserInfo(res.data.data.token);
          this.setState({
            loader: false,
            success: true
          });
          this.props.history.push("/signup/complete", { provider: 'signup' });
        } catch (error) {
          handleActionError("An error occurred while signing up the subscriber:", error);
        }
        this.props.hideLoader();
        this.props.resetSignupFlow();
      })
      .catch(err => {
        this.props.hideLoader();
        this.setState({
          message: err.response && err.response.data.message,
          btnDisabled: false
        });
      });
  }


  checkEmail = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      this.setState({
        [formName]: returnFormConfig.form,
        btnDisabled: true
      });
      this.props.showLoader();
      for (let formElementIdentifier in this.state[formName]) {
        formData[formElementIdentifier] = this.state[formName][
          formElementIdentifier
        ].value;
      }
      axiosUserManagement
        .post("/validateSubscriber", formData, {
          "cache-control": "no-cache",
          "content-type": "application/json"
        })
        .then(res => {
          this.props.setSignupInfo(formData);
          const sendData = {
            ...formData,
            isSubscribedForNewsLetter: true,
            subscriberInvestDomainId: null,
            subscriberRoleId: null
          }
          if (this.campaignValue) {
            this.signUpHandler(sendData)
          } else {
            this.signUpHandler(sendData)
          }
          analytics("registration_email_form_filled");
          this.props.setSignupFlow();
          this.props.hideLoader();
        })
        .catch(err => {
          handleActionError("An error occurred while attempting to validate the subscriber:", err);
          this.props.hideLoader();
          this.setState({
            message: err.response && err.response.data.message,
            btnDisabled: false
          });
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  getUserInfo = token => {
    if (!IsEmpty(token)) {
      this.props.setUser(token);
    }
  };

  closeModal = () => {
    this.resetPopupProps();
    this.props.setSignupModalStatus(false);
  };

  resetPopupProps = () => {
    this.setState({
      openPopup: false
    });
  };


  render() {
    return (
      <>
        <Modal
          openPopup={this.state.openPopup}
          resetPopupProps={this.resetPopupProps}
          modalID="signInModal"
          key={this.state.openPopup}
        >
          <>
            {this.props.signUpModalRequestedForm == 'signin' &&
              <div className="col-12 no-gutter-col padding0">
                <div className="signInUpFlowPopup">
                  <div className="modal-header border-bottom-0">
                    <button
                      type="button"
                      className="close cross"
                      data-dismiss="modal"
                      onClick={() => this.closeModal()}
                    >

                    </button>
                  </div>

                  <div className="modal-body">
                    <Sign
                      form={objectToArray(this.state.SigninConfig)}
                      formName="SigninConfig"
                      btnDisabled={this.state.btnDisabled}
                      onChangeHandler={this.onChangeHandler}
                      onBlurHandler={this.onBlurHandler}
                      sucessHandler={this.signInHandler}
                      message={this.state.message}
                      sucessState={this.state.success}
                      changeFormHandler={this.onFormChangeHandler}
                    />
                  </div>
                </div>
              </div>
            }
            {this.props.signUpModalRequestedForm == 'signup' &&
              <>
                <div className="col-12 no-gutter-col padding0">
                  <div className="modal-header border-bottom-0">
                    <button
                      type="button"
                      className="close cross"
                      data-dismiss="modal"
                      onClick={() => this.closeModal()}
                    >

                    </button>
                  </div>
                  <div className={this.state.activeStep === SiteConstants.SignupForm ? "signInUpFlow" : "signup_new"}>
                    {this.state.activeStep === SiteConstants.SignupInit && (
                      <SignupInit
                        lazyLoadComponent={this.lazyLoadComponent}
                        nextPage={SiteConstants.SignupForm}
                        message={this.state.message}
                        changeFormHandler={this.onFormChangeHandler}
                      />
                    )}
                    {this.state.activeStep === SiteConstants.SignupForm && (
                      <SignupForm
                        lazyLoadComponent={this.lazyLoadComponent}
                        nextPage={SiteConstants.SignupPreferences}
                        form={objectToArray(this.state.SignupConfig)}
                        formName="SignupConfig"
                        btnDisabled={this.state.btnDisabled}
                        onChangeHandler={this.onChangeHandler}
                        onBlurHandler={this.onBlurHandler}
                        sucessHandler={this.checkEmail}
                        message={this.state.message}
                        sucessState={this.state.success}
                        changeFormHandler={this.onFormChangeHandler}
                      />
                    )}
                  </div>
                </div>
              </>
            }
          </>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider,
    signUpModalRequestedForm: state.signup.signUpModalRequestedForm
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    setSignupInfo: signUpInfo => dispatch(setSignupInfo(signUpInfo)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
    setSignupFlow: () => dispatch(setSignupFlow()),
    resetSignupFlow: () => dispatch(resetSignupFlow()),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SigninPopup));
